import { Component, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Viewdata, GlobalMessage,Invalidfileextensions } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { InvalidfileextensionsService } from './invalidfileextensions.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { InvalidfileextensionsmodalComponent } from '../../directives/invalidfileextensionsmodal/invalidfileextensionsmodal.component';

@Component({
  selector: 'app-invalidfileextensions',
  templateUrl: './invalidfileextensions.component.html',
  styleUrls: ['./invalidfileextensions.component.css']
})
export class InvalidfileextensionsComponent {

  dataForm: FormGroup
  selectedItem: MenuItem | null = null;
  items: MenuItem[] | undefined;
  tableData: any[] = [];
  showcount: number = 0;
  hidecount: number = 0;
  searchText: string;
  sortOrder = 1;
  datalist: any;
  datalistarray: Array<Invalidfileextensions> = [];
  dataview: Viewdata = new Viewdata();
  ref: DynamicDialogRef | undefined;
  buttunText = "Add New"
  isButtonraised: boolean = true;
  commonScrollHeight = '';
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 20, 50, 100];
  tablecount: number = 0;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  selectedProduct = false;
  options = [];
  paginatorArray
  visible: boolean = false;
  psition = 'top';
  cols = [];
  _selectedColumns = [];
  bulkModal = false;
  message: GlobalMessage = new GlobalMessage()
  isEdit = false;
  isAdd = true;
  isClose = false;
  isView = false;
  isTableHeaderCustomized: boolean = false;
  isActivefilter = false
  multiSortMeta = [
    { field: 'source', order: 1 },   // primary sort ascending
    { field: 'fileextension', order: 1 }   // secondary sort ascending
  ];
  CSRFToken = "";

  constructor(
    private InvalidfileextensionsService: InvalidfileextensionsService,
    public router: Router,
    private fb: FormBuilder,
    public dialogService: DialogService,
    //private dashbordservice: DashboardService,
    public helpservice: PagehelpmodalService,
    private utilityservice: Utilityservice, private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.gettabledata();
    this.formInitialized();
    this.dynamiccols(); 
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  dynamiccols() {
    this.showcount = 8;
    this.hidecount = 3;
    this.cols = [];

    this.cols.push(
      { fieldname: 'id', headername: 'ID', fieldtype: 'text', issort: true, ischecked: true, width: '2px !important', class: 'headerid' },
      { fieldname: 'source', headername: 'Source', fieldtype: 'text', issort: true, ischecked: true, width: '2px !important', class: 'headerid' },
      { fieldname: 'fileextension', headername: 'File Extension', fieldtype: 'text', issort: true, ischecked: true, width: '2px !important', class: 'otherheader' },
      { fieldname: "createdon", headername: "Created On", fieldtype: 'text', issort: false, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "createdby", headername: "Created By", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "activeflag", headername: "Status", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
    )

    const payload = {
      userid: this.utilityservice.getLoggeduser().userid,
      orgid: this.utilityservice.getLoggeduser().orgid,
      productid: this.utilityservice.productdetail().productid,
      componentname: 'invalidfileextensions'
    }
    this.spinner.show();
    this.utilityservice.getuserxcolumn(payload).subscribe(res => {
      this.spinner.hide();
      this.cols.forEach(column => {
        const matchingColumn = res.find(x => x.fieldname === column.fieldname);
        if (matchingColumn) {
          column.ischecked = matchingColumn.ischecked;
          column.issort = matchingColumn.issort;
        }
      });
      this._selectedColumns = this.cols;
      this.isTableHeaderCustomized = this.cols.some(col => col.ischecked !== true);
    }, error => {
      this.spinner.hide();
      console.error('Error getting user columns:', error);
      Swal.fire('Error getting header filter', 'Please try again later', 'error');
    })
    this.utilityservice.headerObservable.next(this.cols);

  }
  showTableColumns() {
    this.isActivefilter = !this.isActivefilter;
  }


  gettabledata() {
    this.InvalidfileextensionsService.gettabledata().subscribe((data) => {
      this.datalist = data;
      this.datalistarray = this.datalist;
      this.options = this.InvalidfileextensionsService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
      this.datalistarray.map(e => {
        e['isSelect'] = false
      })
      this.totalRecords = this.datalistarray.length;
      this.tablecount = this.datalist.count;
    });

    this.InvalidfileextensionsService.gettabledata().subscribe((data: any) => {
      this.datalist = data;
    });
  }

  show(title, data) {
    let details = {}
    if (title === 'Modify Invalid File Extension') {
      this.isEdit = true;
      this.InvalidfileextensionsService.getmodify(data.id).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(InvalidfileextensionsmodalComponent, {
          header: title,
          width: '50vw',
          height: 'auto',
          data: { title: title, datas: details },
          contentStyle: { overflow: 'auto' },
          baseZIndex: 10000,
          maximizable: false,
        });
        this.ref.onClose.subscribe(() => {
          this.getsignatory();
        });
      })
    }
    else {
      details = {}
      this.ref = this.dialogService.open(InvalidfileextensionsmodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000,
        maximizable: false,
      });
      this.ref.onClose.subscribe(() => {
        this.getsignatory();
      });
    }
  }


  //Get signatory by Id
  tempuse: any;
  getsignatory() {
    this.spinner.show();
    this.InvalidfileextensionsService.gettabledata().subscribe((data) => {
      this.datalist = data;
      this.datalistarray = this.datalist;
      this.tablecount = this.datalist.count;
      this.spinner.hide();
      this.options = this.InvalidfileextensionsService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
    }
      , error => {
        this.spinner.hide();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.error.error,
          footer: "error status is :" + ' ' + error.status
        });
      });
  }


  formInitialized() {
    this.dataForm = this.fb.group({
      fileexenstion: [''],
      id: [''],
      activeflag: ['Y']
    })
  }
  handlePageChange(event: any) {
    this.rows2 = event.rows
  }
  filedata: any = []
  setEvent(event) {
    this.filedata = event

  }

  handleDialogClose() {
    this.filedata = [];
  }


  delete(id: number) {
    const payload = {
      id: id,
      csrftoken: this.CSRFToken
    }

    Swal.fire({
      title: "Do you want really want to DELETE the Invalid File Extension?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Delete",
      denyButtonText: `Don't Delete`
    })
      .then((value) => {
        if (value.isConfirmed) {
          this.InvalidfileextensionsService.delete(payload).subscribe(() => {
            Swal.fire("Invalid File Extension is deleted successfully!", "", "success").then(() => {
              window.location.reload(); this.getsignatory();

            });
          }, error => {
            Swal.fire(error.error.message, '', 'error');
          });
        } else if (value.isDenied) {
          Swal.fire("Invalid File Extension is not deleted", "", "info")
        }
      });
  }


  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;
      // Convert date strings to Date objects if they are valid date formats
      const isDate = (date) => !isNaN(Date.parse(date));

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        // Check for specific sorting logic for processstepname
        if (event.field === 'title') {
          result = value1.toLowerCase().localeCompare(value2.toLowerCase());
        } else if (isDate(value1) && isDate(value2)) {
          const date1 = new Date(value1);
          const date2 = new Date(value2);
          result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
        } else {
          result = value1.localeCompare(value2);
        }
      } else {
        // Fallback to default number comparison
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;  // Multiply by order (-1 for descending, 1 for ascending)
    });
  }
}
